import React, { useCallback, useContext, useMemo, useState } from 'react'
import { Input } from 'components/inputs'
import { Button } from 'components/buttons'
import { dialogTypes } from 'dialogs'
import { Row, Col, Label } from 'reactstrap'
import { Validator } from 'components/validation'
import { Select } from 'components/select'
import { AddItemButton } from 'components/buttons'
import { api as evaluatorsApi } from 'store/modules/lookups/evaluators'
import { useStyles } from './item.css'
import { ValidationContext } from 'components/validation/validationContext'

export const WineEvaluationItem = (props) => {

  const { wineEvaluation, disabled, localize, index, onUpdate, canRemove, isInDialog } = props

  const { evaluator, evaluation } = wineEvaluation
  const classes = useStyles()
  const { clearErrors } = useContext(ValidationContext)
  const [isRemoved, setIsRemoved] = useState(false)
  const evaluatorName = useMemo(() => `evaluator[${index}]`, [index])
  const evaluationName = useMemo(() => `evaluation[${index}]`, [index])

  const onEvaluatorChange = useCallback(x => {
    onUpdate({ wineEvaluation: { evaluator: x, evaluation }, index })
  }, [onUpdate, index, evaluation])

  const onEvaluationChange = useCallback(x => {
    onUpdate({ wineEvaluation: { evaluation: x, evaluator }, index })
  }, [onUpdate, index, evaluator])

  const onRemove = useCallback(() => {
    setIsRemoved(true)
    onUpdate({ wineEvaluation: null, index })
    setTimeout(() => clearErrors([evaluatorName, evaluationName]), 10)
  }, [onUpdate, index, clearErrors, evaluatorName, evaluationName])

  const sm = useMemo(() => isInDialog ? 4 : 3, [isInDialog])

  return (
    <Col sm={sm} className={classes.item}>
      <Row>
        <Col>
          <Label>{localize('wines.evaluator')}</Label>
          <AddItemButton dialogType={dialogTypes.evaluatorDetail} disabled={disabled} onCreatedEntity={onEvaluatorChange}>
            <Validator name={evaluatorName} value={wineEvaluation.evaluator} required disabled={disabled || isRemoved}>
              <Select
                dataSource={evaluatorsApi.get}
                value={wineEvaluation.evaluator}
                onChange={onEvaluatorChange}
                nullable
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
      </Row>
      <Row>
        <Col>
          <Label>{localize('wines.evaluation')}</Label>
          <Validator name={evaluationName} value={wineEvaluation.evaluation} required min={0} max={100} disabled={disabled || isRemoved}>
            <Input isNumeric precision={2} disabled={disabled} value={wineEvaluation.evaluation} onChange={onEvaluationChange} />
          </Validator>
        </Col>
      </Row>
      {!disabled && canRemove && <Button
        className={classes.remove}
        color='secondary'
        title={localize('wines.removeEvaluationTooltip')}
        width={32}
        onClick={onRemove}
        icon='times'></Button>}
    </Col>
  )
}
